import { z } from 'zod';
import { validatedGet, validatedDelete } from '../api-client.ts';
import { CodaConCountSchema, DelegaArricchitaSchema } from '@/types/api-responses.ts';
import { OkResult } from './shared.ts';

const CodeListResult = z.object({
  code: z.array(CodaConCountSchema),
});

const DelegheResult = z.object({
  deleghe: z.array(DelegaArricchitaSchema),
  count: z.number(),
});

const DeleteCodaResult = z.object({
  ok: z.literal(true),
  delegheRipristinate: z.number(),
});

export const codeApi = {
  lista: () =>
    validatedGet('code', CodeListResult),

  dettaglio: (id: number) =>
    validatedGet(`code/${id}`, CodaConCountSchema),

  deleghe: (id: number) =>
    validatedGet(`code/${id}/deleghe`, DelegheResult),

  elimina: (id: number) =>
    validatedDelete(`code/${id}`, DeleteCodaResult),

  eliminaDelega: (codaId: number, delegaId: number) =>
    validatedDelete(`code/${codaId}/deleghe/${delegaId}`, OkResult),
};
